import { Link } from "@mui/material";
import { GridCellParams } from "@mui/x-data-grid";
import { Link as RouterLink } from "react-router-dom";
import { AssignmentPeriod } from "../assignmentPeriod/type";

export default function AssignmentPeriodDetailButton(props: GridCellParams<AssignmentPeriod, any>) {
    return <Link component={RouterLink} to={props.row.assignmentPeriodCode.toString()}>Detay</Link>
}